// Kliks op de contactkanalen (bellen, WhatsApp, chat, e-mail) als GA4-event "contact_click".
// GA verstuurt pas iets na toestemming "Statistieken" (ga-disable in analytics.ts); daarvoor gaat er niets weg.

export type ContactMethode = "phone" | "whatsapp" | "chat" | "email";

export function contactMethode(href: string): ContactMethode | null {
  const link = href.trim().toLowerCase();
  if (link.startsWith("tel:")) return "phone";
  if (link.startsWith("mailto:")) return "email";
  if (/^https?:\/\/(wa\.me|api\.whatsapp\.com|(www\.)?whatsapp\.com)\//.test(link)) return "whatsapp";
  if (/^https?:\/\/go\.crisp\.chat\//.test(link)) return "chat";
  return null;
}

type Gtag = (...args: unknown[]) => void;

export function meetContactKliks(doc: Document, gtag: () => Gtag | undefined) {
  doc.addEventListener("click", (event) => {
    const link = (event.target as Element | null)?.closest?.("a[href]") as HTMLAnchorElement | null;
    const methode = link ? contactMethode(link.getAttribute("href") ?? "") : null;
    if (!methode) return;
    gtag()?.("event", "contact_click", { method: methode, link_location: doc.location?.pathname ?? "" });
  }, { capture: true });
}
